export const GET_PERSON_EVALUATIONS_REQUEST = "GET_PERSON_EVALUATIONS_REQUEST";
export const GET_PERSON_EVALUATIONS_REQUEST_SUCCEDED = "GET_PERSON_EVALUATIONS_REQUEST_SUCCEDED";
export const GET_PERSON_EVALUATIONS_REQUEST_FAILED = "GET_PERSON_EVALUATIONS_REQUEST_FAILED";
